import { combineReducers } from 'redux';
import { authentication } from './authentication.reducers';
import { alert } from './alert.reducers';
import { jobProfiles } from './jobProfile.reducers';
import { applicant } from './applicant.reducer'
import { notification } from "./notification.reducers"
import { resources } from "./resource.reducers"
import { masterData } from "./masterData.reducer"
import { company } from './company.reducers';
import { googleCalendar } from './googleCalendar.reducers';
const rootReducer = combineReducers({
    authentication,
    alert,
    jobProfiles,
    applicant,
    notification,
    resources,
    masterData,
    company,
    googleCalendar
});

export default rootReducer;